import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth, GoogleAuthProvider } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

function normalizeStorageBucket(input) {
  const raw = String(input || "").trim();
  if (!raw) return "";
  if (raw.startsWith("gs://")) return raw.replace(/^gs:\/\//, "").split("/")[0];

  // Support accidentally-pasted API URLs like:
  // https://firebasestorage.googleapis.com/v0/b/<bucket>/o
  if (raw.includes("firebasestorage.googleapis.com")) {
    try {
      const url = new URL(raw);
      const match = url.pathname.match(/\/v0\/b\/([^/]+)\//i);
      if (match?.[1]) return match[1];
    } catch {}
  }

  // Support generic https bucket URLs.
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw);
      if (url.hostname === "storage.googleapis.com") {
        return (url.pathname || "").replace(/^\/+/, "").split("/")[0];
      }
      return url.hostname;
    } catch {}
  }

  return raw.split("/")[0];
}

const normalizedStorageBucket = normalizeStorageBucket(process.env.REACT_APP_FIREBASE_STORAGE_BUCKET);

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: normalizedStorageBucket || undefined,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

const isExplicitRuntimeEmulatorBuild =
  process.env.FAST_REFRESH === false &&
  process.env.REACT_APP_FIREBASE_USE_EMULATORS === "true";

if (isExplicitRuntimeEmulatorBuild) {
  const emulatorHost =
    String(process.env.REACT_APP_FIREBASE_EMULATOR_HOST || "127.0.0.1").trim() ||
    "127.0.0.1";
  const authPort = Number(process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_PORT || 9099);
  const firestorePort = Number(
    process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080
  );
  connectAuthEmulator(auth, `http://${emulatorHost}:${authPort}`, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, emulatorHost, firestorePort);
}

export const functionsClient = getFunctions(app, "europe-west1");
export const storage = normalizedStorageBucket
  ? getStorage(app, `gs://${normalizedStorageBucket}`)
  : getStorage(app);
